import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import { useItemDisplayDimensions } from '../helpers/useItemDisplayDimensions';

import { type ViewInRoomImageCredits_user$key } from './__generated__/ViewInRoomImageCredits_user.graphql';
import { type ViewInRoomImageCredits_viewInRoomPhoto$key } from './__generated__/ViewInRoomImageCredits_viewInRoomPhoto.graphql';
import { type ViewInRoomImageCredits_item$key } from './__generated__/ViewInRoomImageCredits_item.graphql';

import styles from './ViewInRoomImageCredits.scss';

const userFragment = graphql`
    fragment ViewInRoomImageCredits_user on User {
        ...useItemDisplayDimensions_user
    }
`;

const viewInRoomPhotoFragment = graphql`
    fragment ViewInRoomImageCredits_viewInRoomPhoto on viewInRoomPhotos {
        credits
    }
`;

const itemFragment = graphql`
    fragment ViewInRoomImageCredits_item on Item {
        ...useItemDisplayDimensions_item
    }
`;

export const ViewInRoomImageCredits: FC<{
    user: ViewInRoomImageCredits_user$key | null | undefined;
    viewInRoomPhoto: ViewInRoomImageCredits_viewInRoomPhoto$key;
    item: ViewInRoomImageCredits_item$key;
}> = ({ user: userRef, viewInRoomPhoto: viewInRoomPhotoRef, item: itemRef }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const viewInRoomPhoto = useFragment(viewInRoomPhotoFragment, viewInRoomPhotoRef);

    const { displayWidth, displayHeight } = useItemDisplayDimensions({ user, item });

    return (
        <div className={styles.wrapper}>
            {`${viewInRoomPhoto.credits}.`}
            <span className={styles.dimensions}>
                <FormattedMessage
                    id="ViewInRoomImageCredits.viewInRoomCredits"
                    defaultMessage="Dimensions: H {height} x W {width}"
                    values={{
                        width: displayWidth,
                        height: displayHeight,
                    }}
                />
            </span>
        </div>
    );
};
